import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full h-full flex flex-col dark:text-white" }
const _hoisted_2 = {
  key: 0,
  class: "h-10 mt-4 flex gap-3 items-center"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "text-[#313030] opacity-60 capitalize text-sm" }
const _hoisted_6 = {
  key: 1,
  class: "h-10 mt-4 flex gap-3 items-center"
}
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = { class: "text-[#313030] opacity-60 capitalize text-sm" }
const _hoisted_9 = { class: "h-fit flex justify-center w-full pt-10 pb-5" }
const _hoisted_10 = {
  key: 2,
  class: "h-[26px] my-3 flex justify-between px-3"
}
const _hoisted_11 = {
  key: 0,
  class: "flex place-items-center"
}
const _hoisted_12 = { class: "ml-2 opacity-90" }
const _hoisted_13 = { class: "opacity-90" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", { class: "text-[#C7CAD2] border border-[#C7CAD2]" }, null, -1)
const _hoisted_15 = { class: "flex justify-between mt-2 pt-5 items-center" }

import { computed, ref, onMounted } from "vue"
  import { parse, format } from "date-fns"
  import { useNewsFeedStore } from "@/store/newsfeed"
  import { HeartIcon } from "@heroicons/vue/24/outline"
  import { useAccountStore } from "@/store/account"
  import { useMetadataStore } from "@/store/metadata"
  import { IonItem } from "@ionic/vue"
  import { toastController } from "@ionic/core"
  import { useRouter } from "vue-router"
  import { useGtm } from "@gtm-support/vue-gtm"

  import ShareButtonContainer from "@/components/template/shareButton.vue"
  import Avatar from "@/components/template/avatarTemplate.vue"

  interface User {
    employment: {
      department: string
      role: string
    }
    name: {
      first_name: string
      full_name: string
      last_name: string
    }
    photo: string
  }

  interface AmbassadorshipAnswer {
    answer: string
    hide: boolean
    question: string
    topic: string
  }
  interface Company {
    location?: unknown
    brand_color: string
    logo: string
    name: string
    slug: string
  }

  interface Answer {
    account_id: string
    answer: string
    answer_id: string
    answers: AmbassadorshipAnswer[]
    associated_company: string
    created: string
    display_link: string
    likes: string[]
    status: string
    tags: string[]
    topic: string
    topic_id: string
    updated: string
  }
  interface Feed {
    content: {
      html: string
    }
    type: string
    account_id: string
    newsfeed_id: string
    created: string
    user: User
    company: Company
    answer_content: {
      answer: Answer
      company: Company
      user: User
    }
  }

  interface Props {
    postData: Feed
    postPageLocation: "world" | string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PostTemplate',
  props: {
    postData: null,
    postPageLocation: null
  },
  setup(__props: any) {

const props = __props as {
    postData: Feed
    postPageLocation: "world" | string
  }

  
  const router = useRouter()
  const gtm = useGtm()

  const newsfeedStore = useNewsFeedStore()
  const shares = ref(0)
  const metadata = useMetadataStore()

  const postType = computed(() => {
    if (props.postData.answer_content?.answer?.answers?.length > 0) return "ambassadorship"
    else if (props.postData.answer_content?.answer?.answers?.length === 0 && props.postData?.content?.html) return "leadership"
    else if (props.postData?.content?.html) return "company"
    else return ""
  })

  const postMeta = computed(() => {
    const obj = {
      url: "",
      title: "",
      description: "",
      media: "",
      twitter: {
        image: "",
      },
      og: {
        image: "",
        type: "",
      },
    }

    if (postType.value && postType.value === "ambassadorship") {
      obj.url = `${metadata.domain}/workbean-world/employee-ambassadorship/${props.postData.newsfeed_id}`
      obj.title = `${props.postData.answer_content.user ? props.postData.answer_content.user.name.first_name : ""}` + "'s " + "employee ambassadorship answers"
      obj.description = props.postData.answer_content.user ? props.postData.answer_content.user.name.first_name : "" + "s" + "employee ambassadorship answers"
      obj.twitter.image = props.postData?.answer_content?.company?.logo
      obj.og.image = props.postData?.company?.logo as string
      obj.og.type = "article"
    } else if (postType.value && postType.value === "leadership") {
      obj.url = `${metadata.domain}/workbean-world/thought-leadership/${props.postData.newsfeed_id}`
      obj.title = `${props.postData?.company?.name}` + " " + `${props.postData?.answer_content?.answer?.topic}` + " " + "thought leadership answer" + " | Workbean.co"
      obj.description =
        props.postData.answer_content && props.postData.answer_content.answer && props.postData.answer_content.answer.topic ? props.postData.answer_content.answer.topic : "" + " | Workbean.co"
      obj.og.image = props.postData?.company?.logo
    } else {
      obj.url = `${metadata.domain}/company/${props.postData?.company?.slug}`
      obj.title = `${props.postData?.company?.name} | Workbean.co`
      obj.description = `${props.postData?.content?.html ? props.postData.content.html : ""}`
      obj.og.image = props.postData?.company?.logo
    }

    return obj
  })

  const postDate = computed(() => {
    const datePosted = parse(props.postData.updated ? props.postData.updated : props.postData.created, "dd/MM/yy HH:mm:ss", new Date())
    return format(datePosted, "PPP")
  })

  const postLiked = ref(false)

  //Checks if user is authenticated, if not show auth wall. If authenticated, like post
  const checkForAuth = () => {
    if (!localStorage.getItem("WBSAASAPP_TK")) {
      router.push("/login")
      return false
    }
    return true
  }

  /**
   * Adds the account ID to likes[] if likeFeed() returns true
   */
  const likePost = async () => {
    if (checkForAuth()) {
      if (postLiked.value) {
        const toast = await toastController.create({
          message: "You already liked this post.",
          duration: 3000,
          position: "top",
          color: "warning",
        })
        await toast.present()
      } else if (!postLiked.value || !props.postData.likes) {
        newsfeedStore.likeFeed(props.postData.newsfeed_id).then((success) => {
          if (success) {
            if (!props.postData.likes) {
              // eslint-disable-next-line vue/no-mutating-props
              props.postData["likes"] = []
              // eslint-disable-next-line vue/no-mutating-props
              props.postData.likes.push(props.postData.account_id)
            } else {
              // eslint-disable-next-line vue/no-mutating-props
              props.postData.likes.push(props.postData.account_id)
            }
            postLiked.value = true
            if (gtm?.enabled()) {
              gtm.trackEvent({
                event: "like_post_event",
                label: "Like Post",
                value: `${props.postData.newsfeed_id}`,
              })
            }
          }
        })
      } else {
        newsfeedStore.likeFeed(props.postData.newsfeed_id)
      }
    }
  }

  /**
   *
   * @param event true if successful update
   *
   * Updates share count
   */
  const updateShare = async (event: boolean) => {
    if (event) {
      shares.value += 1
      const toast = await toastController.create({
        message: "Post shared to the World successfully.",
        duration: 3000,
        position: "top",
        color: "success",
      })
      await toast.present()
    }
  }

  onMounted(async () => {
    if (props.postData.likes) postLiked.value = await props.postData.likes.includes(useAccountStore().account_id)
    if (props.postData.shares && props.postData.shares.length) {
      shares.value = props.postData.shares.length
    }
  })

return (_ctx: any,_cache: any) => {
  return (__props.postData.answer_content || __props.postData.content.html)
    ? (_openBlock(), _createBlock(_unref(IonItem), {
        key: 0,
        id: __props.postData?.newsfeed_id,
        class: "min-w-full h-fit rounded-2xl shadow-md py-4 text-primary-black mb-5"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (__props.postData.company)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(Avatar, {
                    name: __props.postData.company?.name,
                    image: __props.postData.company?.logo
                  }, null, 8, ["name", "image"]),
                  _createElementVNode("div", null, [
                    _createElementVNode("a", {
                      href: `/company/${__props.postData.company?.slug}`
                    }, [
                      _createElementVNode("h2", _hoisted_4, _toDisplayString(__props.postData.company?.name), 1)
                    ], 8, _hoisted_3),
                    _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(postDate)), 1)
                  ])
                ]))
              : (__props.postData.user)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(Avatar, {
                      name: __props.postData.user?.name.full_name,
                      image: __props.postData?.user.photo
                    }, null, 8, ["name", "image"]),
                    _createElementVNode("div", null, [
                      _createElementVNode("h2", _hoisted_7, _toDisplayString(__props.postData.user?.name.first_name) + " " + _toDisplayString(__props.postData.user?.name.last_name), 1),
                      _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(postDate)), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _renderSlot(_ctx.$slots, "default")
            ]),
            (__props.postData.likes?.length || __props.postData.shares?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (__props.postData.likes?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["h-full w-[26px] rounded-full pt-1", postLiked.value ? 'bg-white' : 'text-primary-violet'])
                        }, [
                          _createVNode(_unref(HeartIcon), {
                            class: _normalizeClass(["h-5 item mx-auto", postLiked.value ? 'text-primary-violet' : 'text-[#65676B]'])
                          }, null, 8, ["class"])
                        ], 2),
                        _createElementVNode("p", _hoisted_12, _toDisplayString(__props.postData.likes.length), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(shares.value > 1 ? `${shares.value} Shares` : `${shares.value} Share`), 1)
                ]))
              : _createCommentVNode("", true),
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_unref(IonItem), { class: "w-fit h-fit" }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "text-[#65676B] font-bold flex items-center w-full mt-1",
                    onClick: likePost
                  }, [
                    _createVNode(_unref(HeartIcon), {
                      id: "heart_button_post",
                      class: _normalizeClass(["mr-3 h-5 heart-button-favorite", postLiked.value ? 'text-primary-violet fill-primary-violet' : 'text-[#65676B]'])
                    }, null, 8, ["class"]),
                    _createTextVNode(" Like ")
                  ])
                ]),
                _: 1
              }),
              _createVNode(ShareButtonContainer, {
                "post-id": __props.postData.newsfeed_id,
                "post-meta": _unref(postMeta),
                onClick: checkForAuth,
                onAddShare: _cache[0] || (_cache[0] = ($event: any) => (updateShare($event)))
              }, null, 8, ["post-id", "post-meta"])
            ])
          ])
        ]),
        _: 3
      }, 8, ["id"]))
    : _createCommentVNode("", true)
}
}

})